















import Component from "vue-class-component";
import headerComponent from '@/components/TheHeader.vue';
import sidebarComponent from '@/components/TheSidebar.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import {Base} from "@/base";

@Component({
  name: 'App',
  components: {
    headerComponent,
    sidebarComponent,
    SidebarRight
  },
})
export default class App extends Base {
  created() {
    window.addEventListener('beforeunload', e => {
      if (this.$store.getters.getMailPending.length > 0) {
        (e || window.event).returnValue = Boolean('');
        return '';
      }
    });
  }

  get openSidebar() {
    return { openSidebar: this.getOpenClose };
  }
};
